import { Stack } from '@chakra-ui/react'
import {
  DEFAULT_LIST_ORDER,
  LIVE_OUTPUT_ORDER_BY_FIELDS,
  listLiveOutputsRequestSchema,
} from '@customTypes/cloudmix/liveOutputs'
import { LiveOutputsTableWrapper } from '@features/liveOutputs/components/LiveOutputsTableWrapper'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { withListHydration } from '@lib/listState/withListHydration'

const LiveOutputRoute = () => (
  <Stack>
    <LiveOutputsTableWrapper />
  </Stack>
)

const routerSchema = listLiveOutputsRequestSchema.partial().catch({})
const routeId = '/_auth/o/$orgId/liveOutputs/' as const

export const Route = createFileRoute(routeId)({
  component: LiveOutputRoute,
  beforeLoad: withListHydration({
    list: {
      routeId,
      defaultSort: [DEFAULT_LIST_ORDER],
      allowedOrderByFields: LIVE_OUTPUT_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Live Outputs',
  }),
  validateSearch: zodValidator(routerSchema),
})
